// extracted by mini-css-extract-plugin
export default {"root":"ListLinks_root__gV8GK"};